import { useCallback } from 'react';
import { ImageLoadEventData, ImageProps, NativeSyntheticEvent } from 'react-native';

import { useFadeInAnimation } from '%hooks/useFadeInAnimation';

export const useImageWithBlurhash = (onLoad: Pick<ImageProps, 'onLoad'>['onLoad']) => {
	const { fadedIn, opacity, startFadeIn } = useFadeInAnimation();

	const handleOnLoad = useCallback(
		(event: NativeSyntheticEvent<ImageLoadEventData>) => {
			if (typeof onLoad === 'function') {
				onLoad(event);
			}

			startFadeIn();
		},
		[onLoad, startFadeIn],
	);

	return { fadedIn, opacity, handleOnLoad };
};
